import { LogoIllumi } from "@src/assets/icons";
import clsx from "clsx";

type IllumiLogoMarkProps = {
	animated?: boolean;
	className?: string;
};

export function IllumiLogoMark({
	animated = false,
	className,
}: IllumiLogoMarkProps) {
	return (
		<div
			className={clsx(
				"illumi-logo-mark",
				animated && "illumi-logo-mark--animated",
				className,
			)}
		>
			<LogoIllumi aria-hidden className="h-full w-full" />
		</div>
	);
}
